import { FC } from 'react'

import { StarSelector } from '@syconium/little-miss-figgy'

import { NextLink } from '../../../../../../../../../app/_components/navigation/NextLink'
import { useStaticAmplitudeTracking } from '../../../../../../../../../app/_hooks/useStaticTracking'
import { EditorialCell } from '../../../../../../../../../types/graphql/collection-view'
import { EditorialCellDescriptionSize, EditorialCellTitle } from '../../types'
import {
  Cta,
  Description,
  DescriptionBody,
  DescriptionWrapper,
  Eyebrow,
  LinkDescription,
  StarWrapper,
  Subtitle,
  Title,
} from '../styles'

interface EditorialCellDescription extends Partial<NonNullable<EditorialCell>> {
  isFloating?: boolean
  showModalCta?: boolean | '' | null
}

const EditorialCellDescription: FC<EditorialCellDescription> = ({
  description,
  isFloating,
  descriptionPadding,
  descriptionAlignment,
  descriptionByLine,
  reviewStars,
  descriptionSize: requestedDescriptionSize,
  linkHref,
  ctaText,
  descriptionColor,
  title,
  titleSize: requestedTitleSize,
  showModalCta,
  titleAlignment,
  textColor,
  subtitle,
  eyebrow,
}) => {
  // We have to cast this because type gen types it as a string due to enum
  // not being an option. There are spaces in its values that would need to
  // be migrated away from to type gen as an enum.
  const descriptionSize = requestedDescriptionSize as
    | EditorialCellDescriptionSize
    | null
    | undefined
  const titleSize = requestedTitleSize as EditorialCellTitle | null | undefined
  const { trackStaticAmplitudeEvent } = useStaticAmplitudeTracking()

  return (
    <DescriptionWrapper textAlign={descriptionAlignment}>
      <DescriptionBody paddingX={descriptionPadding} isFloating={isFloating}>
        {title && (
          <Title
            titleSize={titleSize}
            titleAlignment={titleAlignment ?? undefined}
            textColor={textColor ?? undefined}
          >
            {title}
          </Title>
        )}
        {subtitle && (
          <Subtitle titleAlignment={titleAlignment ?? undefined} textColor={textColor}>
            {subtitle}
          </Subtitle>
        )}
        {reviewStars === true && (
          <StarWrapper textAlign={descriptionAlignment}>
            <StarSelector disabled rating={5} starSize='18px' />
          </StarWrapper>
        )}
        {eyebrow && <Eyebrow textAlign={descriptionAlignment}>{eyebrow}</Eyebrow>}
        {description && (
          <Description descriptionColor={descriptionColor} fontSize={descriptionSize}>
            {description}
          </Description>
        )}
        {linkHref ? (
          <Cta
            as={NextLink}
            href={linkHref}
            color={descriptionColor || textColor}
            onClick={() =>
              trackStaticAmplitudeEvent({ modifiedElement: 'Module Link', href: linkHref })
            }
          >
            {ctaText}
          </Cta>
        ) : (
          !showModalCta && <Cta color={descriptionColor || textColor}>{ctaText}</Cta>
        )}
        {descriptionByLine && (
          <LinkDescription textAlign={descriptionAlignment}>- {descriptionByLine}</LinkDescription>
        )}
      </DescriptionBody>
    </DescriptionWrapper>
  )
}

export default EditorialCellDescription
